import classNames from 'classnames';
import { colors, fonts } from 'components/styles/variables';
import { useTranslation } from 'react-i18next';
import { ButtonHTMLAttributes, useState, useEffect } from 'react';

export interface NumberSelectorProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onChange'> {
  number: number;
  isActive?: boolean;
  onChange?: (isActive: boolean) => void;
}

export default function NumberSelector({
  number,
  isActive: initialIsActive,
  onChange,
}: NumberSelectorProps): JSX.Element {
  const { t } = useTranslation();

  const [isActive, setIsActive] = useState(initialIsActive);
  useEffect(() => {
    setIsActive(initialIsActive);
  }, [initialIsActive]);

  const handleClick = (): void => {
    const newVal = !isActive;
    onChange?.(newVal);
    setIsActive(newVal);
  };

  return (
    <>
      <button
        className={classNames(isActive ? 'active' : 'inactive', 'number-selector')}
        onClick={handleClick}
        aria-label={`${t('srp.filters.numberSelector')} ${number}`}
      >
        {number}
      </button>
      <style jsx>{`
        .number-selector {
          width: 34px;
          height: 34px;
          border-radius: 25px;
          cursor: pointer;
          font-family: ${fonts.default};
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .inactive {
          border: 1px solid ${colors.BLACK};
          background-color: ${colors.WHITE};
        }

        .active {
          border: none;
          background-color: ${colors.ALR1};
          color: ${colors.WHITE};
          font-weight: 700;
        }

        .inactive:hover {
          background-color: ${colors.G1};
        }
      `}</style>
    </>
  );
}
